import { asyncComputedFlow } from '@adv-frontend/modules-flow';
import type { Nullable } from '@direct-frontend/stdlib';
import type { AnyDataProvider, DataProviderWithSubRows, InferDataProviderRowData } from '../types';

/**
 * Добавляет к строкам метод для получения дата провайдера подстрок строки
 * @param dataProvider - дата провайдер строк
 * @param createSubRowsDataProvider - функция для создания дата провайдера подстрок строки
 * @typeParam RowData - тип данных строки
 * @typeParam SubRowsDataProvider - тип дата провайдера подстрок строки
 * @typeParam TDataProvider - тип исходного дата провайдера (сохраняется при расширении)
 * @returns дата провайдер строк с методом для получения дата провайдера подстрок строки
 */
export function withSubRows<TDataProvider extends AnyDataProvider, TSubRowsDataProvider extends AnyDataProvider>(
    dataProvider: TDataProvider,
    createSubRowsDataProvider: (row: InferDataProviderRowData<TDataProvider>) => Nullable<TSubRowsDataProvider>
): DataProviderWithSubRows<TDataProvider, TSubRowsDataProvider> {
    const subRowsDataProvider = asyncComputedFlow<Nullable<TSubRowsDataProvider>, string>(function* (
        { watchAsync },
        id: string
    ) {
        const rowDataFlow = dataProvider.rowData(id);
        const rowData = yield* watchAsync(rowDataFlow);
        return createSubRowsDataProvider(rowData);
    });

    return {
        ...dataProvider,
        subRowsDataProvider,
    };
}
